<template>
    <span>
    <i  class='dropdown-trigger material-icons right grey-text text-darken-1' :data-target="id" @click="expand()" v-if='renderAdd()'>{{dropDownIcon}}</i>
    <ul v-if="open" :id="id" class='dropdown-content' >
        <li v-for="(action, name) of actions" v-bind:key="name"><a @click="action">{{ name }}</a></li>
    </ul>
    </span>
</template>
<style scoped>
    a{
        cursor: pointer;
        border-bottom: 1px solid lightgray;
    }
    .dropdown-content{
        width: 110px !important;
    }
</style>

<script>
export default {
    name: 'dropDown',
    props:{
        actions: Object,
        tag: Array,
        dropDownIcon: "",
        settingsTab: false,
    },
    data(){
        return {
            instance: null,
            id:Math.random().toString(36).substr(2, 9),
            open: false,
        }
    },
    methods:{
        expand(){
            var searchRendered = this.$parent.$parent.searchResultRendered;
            if(this.tag && this.tag[0]=="start" & searchRendered){
                return;
            }
            if(!this.open){
                this.open = true
            }
        },
         renderAdd(){
            if(this.tag && this.tag[0] == "start"){
                return !this.$parent.$parent.searchResultRendered; 
            }else{
                return true;
            }

        }
    },
    updated(){
        if(this.$el.querySelector(".dropdown-trigger") && this.$el.querySelector(".dropdown-content") && open){
            this.instance = M.Dropdown.init(this.$el.querySelector(".dropdown-trigger"), {onCloseEnd:()=>{this.open = false; this.instance.destroy()}});
            this.instance.open()
        }
    }
}
</script>
